import React, { useCallback } from 'react';
import ComplexBlockRenderer from './ComplexBlockRenderer';
import { withTranslation } from 'react-i18next';
import { useDocumentContext } from '../../context/complexDocumentContext';
import { dummyCallback } from '../../utils/complexDocumentConstants';
import {
  useArtboardContext,
  CONTEXT_KEYS,
  TEMPLATE_TYPE,
} from '../../context/complexArtboardContext';
import { block_Selection } from '../../utils/helper';

const NAMESPACES = ['COMPLEX_PAGE_OPTIONS'];

const StandaloneBlock = props => {
  const { t, itemUUID, editable, parentUUID, pageId, getElementStyles, showVersionSettings, ...rest } = props;

  const customSelector = useCallback(store => store[itemUUID], []);
  const [standaloneBlock, methods] = useDocumentContext(
    customSelector,
    `StandaloneBlock-${itemUUID}`,
  );

  const artboardContextSelector = useCallback(store => store, []);
  const [, updateArtboard] = useArtboardContext(
    artboardContextSelector,
    `StandaloneBlock-${itemUUID}`,
  );

  const selectedBlockSelector = useCallback(store => store[CONTEXT_KEYS.SELECTED_BLOCKS], []);
  const [selectedBlocks] = useArtboardContext(selectedBlockSelector, `TextBlock-${itemUUID}`);

  const selectedBlocksParentSelector = useCallback(
    store => store[CONTEXT_KEYS.SELECTED_BLOCKS_PARENT],
    [],
  );
  const [selectedBlocksParent] = useArtboardContext(
    selectedBlocksParentSelector,
    `CreativeBlockDesign-${itemUUID}`,
  );

  const headerOrFooterSelectedSelector = useCallback(
    store => store[CONTEXT_KEYS.HEADER_OR_FOOTER_BLOCK_SELECTED],
    [],
  );
  const [isHeaderOrFooterSelected] = useArtboardContext(
    headerOrFooterSelectedSelector,
    `CreativeBlockDesign-${itemUUID}`,
  );

  const contentSelectedSelector = useCallback(
    store => store[CONTEXT_KEYS.CONTENT_BLOCK_SELECTED],
    [],
  );
  const [isContentSelected] = useArtboardContext(
    contentSelectedSelector,
    `CreativeBlockDesign-${itemUUID}`,
  );

  const currentDesignSelector = useCallback(
    store =>
      [TEMPLATE_TYPE.DOCUMENT, TEMPLATE_TYPE.FLOW].includes(store[CONTEXT_KEYS.CURRENT_DESIGN]),
    [],
  );
  const [isDocumentOrFlowDesign] = useArtboardContext(currentDesignSelector, 'CreativeBlockDesign');

  const blockSelection = useCallback(
    e => {
      if (e.ctrlKey || e.metaKey) {
        block_Selection({
          selectedBlocks,
          itemUUID,
          parentUUID,
          flowDetails: methods.get()[parentUUID],
          selectedBlocksParent,
          isHeaderOrFooterSelected,
          isContentSelected,
          updateArtboard,
          methods,
          t,
        });
      }
    },
    [
      isContentSelected,
      isHeaderOrFooterSelected,
      itemUUID,
      methods,
      parentUUID,
      selectedBlocks,
      selectedBlocksParent,
      updateArtboard,
      t,
    ],
  );

  const blockSelected = selectedBlocks.includes(itemUUID);

  const onDoubleClick = () => updateArtboard({ [CONTEXT_KEYS.STANDALONE_BLOCK_EDIT]: itemUUID });
  return (
    <div
      onMouseMove={e => !showVersionSettings && getElementStyles(e, standaloneBlock.uuid)}
      onClick={isDocumentOrFlowDesign && blockSelection}
      onDoubleClick={onDoubleClick}
      style={{ background: blockSelected && '#ACCEF7' }}
    >
      {standaloneBlock.contents?.map(blockUUID => (
        <ComplexBlockRenderer
          key={blockUUID}
          itemUUID={blockUUID}
          editable={false}
          parentUUID={parentUUID}
          pageId={pageId}
          getElementStyles={dummyCallback}
          {...rest}
        />
      ))}
    </div>
  );
};

export default React.memo(withTranslation(NAMESPACES)(StandaloneBlock));
